<mat-dialog-content class="modal-header">
  <h2 mat-dialog-title>Confirmación</h2>
</mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
  <mat-dialog-content class="modal-body">
    <div class="">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-12 control-label">¿Esta seguro que desea adicionar mas información a la solicitud?</label>
          <label class="col-md-12 control-label">Nota: De aceptar, la solicitud retrocederá al estado Observado donde el contratista podrá completar mas información (personal, vehículo, etc.)</label>
        </div>
        <div class="form-group">
          <label class="col-md-3 control-label">Comentarios (*):</label>
          <div class="col-md-9">
            <mat-form-field class="example-full-width" appearance="outline" hideRequiredMarker>
              <mat-label>Ingresa los comentarios</mat-label>
              <textarea
                [(ngModel)]="model.comentarios"
                matInput
                placeholder="Comentarios"
                rows="5"
                name="comentarios" [maxlength]="2000"
                required
              >
              </textarea>
              <!-- [(ngModel)]="model.comentarios"> -->
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="modal-actions">
    <button
      type="submit"
      class="btn btn-naranja"
      mat-button
      [mat-dialog-close]="model"
      [disabled]="modelForm.invalid"
      cdkFocusInitial
    >
      <mat-icon>send</mat-icon> Enviar
    </button>
    <button
      type="button"
      class="btn btn-naranja2"
      mat-button
      (click)="onNoClick()"
    >
      <mat-icon>exit_to_app</mat-icon> Cancelar
    </button>
  </mat-dialog-actions>
</form>

<!-- <pre>{{ model | json}}</pre> -->